<template>
  <div style="display: none" />
</template>

<script>
/* eslint-disable */
export default {
  name: 'RadioDefaultValueEditor',
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object,
  },
}
</script>

<style scoped>

</style>
